export enum AuthCodes {
  INVALID_USER = 'invalid-user',
  INVALID_PASS = 'invalid-pass',
}
